<template>
  <a-card :bordered='false' class="forgetPasswordTwo">
    <div class="form">
       <h3 class="s_c376 fz-18 s_font_b" >找回密码</h3>
       <div class="m-t-30 m-b-30 m-l-50 fz-16 s_c333">
         您正在为 <span class="s_c376 s_font_b"> {{$route.query.account}} </span> 的高大永恒塑料制品有限公司账号找回密码，请选择身份验证
       </div>
       <ul v-if="$route.path=='/forgetpasswordtwo'">
         <!-- 扫码 -->
          <!-- <li class="s_flex_bian_c pad base_border s_bor10 m-b-35">
             <div class="m-r-10 text-ac width-60 height-60 base_border">
               <img src="@/assets/images/weixin1-01.png" alt="" style="width:100%">
             </div>
             <div class="flex_1">
               <p class="s_c333 fz-16">绑定的个人微信号进行扫码</p>
               <p class="s_c8e fz-12">仅针对通过微信扫码注册的用户或者已绑定个人微信号的用户</p>
             </div>
             <div class="">
               <a-button type="primary" class="width-100 height-40 bora5" @click="$router.push('/forgetpasswordtwo/qrcodeverification?account='+$route.query.account)">立即验证</a-button>
             </div>
          </li> -->
          <!-- 手机 -->
          <li class="s_flex_bian_c pad base_border s_bor10 m-b-35">
            <!-- 图 -->
             <div class="m-r-10 text-ac width-60 height-60 base_border">
               <img src="@/assets/images/weixin1-02.png" alt="" style="width:100%">
             </div>
             <div class="flex_1">
               <p class="s_c333 fz-16">通过手机验证码</p>
               <p class="s_c8e fz-12">仅针对已绑定手机号的用户</p>
             </div>
             <div class="">
               <a-button type="primary" class="width-100 height-40 bora5" @click="$router.push('/forgetpasswordtwo/phoneverification?account='+$route.query.account)">立即验证</a-button>
             </div>
          </li>
          <!-- 人工 -->
          <li class="s_flex_bian_c pad base_border s_bor10">
            <!-- 图 -->
             <div class="m-r-10 text-ac width-60 height-60 base_border">
                <img src="@/assets/images/weixin1-03.png" alt="" style="width:100%">
             </div>
             <div class="flex_1">
               <p class="s_c333 fz-16">通过人工服务</p>
               <p class="s_c8e fz-12">请联系 15013197728</p>
             </div>
          </li>
       </ul>
       <router-view v-else/>
    </div>
  </a-card>
</template>
<script>
// import { BulbTwoTone } from '@ant-design/icons-vue';
// import { sendForget } from '@/api/login';
// import { reactive, ref,inject } from 'vue';
// import { iscode } from "@/utils/app";
import { onMounted,inject } from 'vue';
export default {
  
  setup() {
    const $router = inject('$router');
    const $route = inject('$route');
    const handleSubmit = () => {};

    //  const $router = inject("$router");
    //  const $route = inject("$route");
    onMounted(()=>{
     
    })
    return {
      handleSubmit,
    };
  },
};
</script>
<style lang='less' scoped>
.forgetPasswordTwo {
  width: 100%;
  height: 100%;

    background-image: url('../../assets/images/login_bg.png');
    background-repeat: no-repeat;
    background-position: 100%;
    background-size: cover;
    display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
  .form {
    width: 800px;
    // margin: 0 auto;
    padding: 50px;
    background-color: #fff;
  }
  .bora5{
    border-radius: 5px;
  }
  .pad{
    padding: 10px 15px;
  }
}
</style>